<sbnb-logo logoLink="/direct" [showBack]="true" (backClicked)="directAddService.goBack()"></sbnb-logo>

<div
  class="grid place-items-center max-w-[1280px] w-full mx-auto min-h-full py-32 px-2"
  [ngClass]="{ 'grid-rows-[auto_1fr]': directAddService.currentStep > -1 }">
  <sbnb-direct-add-select-type *ngIf="directAddService.currentStep === -1"></sbnb-direct-add-select-type>

  <sbnb-progress-stepper
    *ngIf="directAddService.currentStep > -1"
    [selectedIndex]="directAddService.currentStep"
    class="w-full max-w-[820px] mb-8">
    <cdk-step *ngFor="let step of directAddService.steps" [label]="step.label" [completed]="step.completed"></cdk-step>
  </sbnb-progress-stepper>

  <sbnb-direct-add-subdomain
    class="w-full max-w-[820px]"
    *ngIf="directAddService.currentStep === 0"></sbnb-direct-add-subdomain>

  <sbnb-direct-add-properties
    class="w-full max-w-[820px]"
    *ngIf="directAddService.currentStep === 1"></sbnb-direct-add-properties>

  <sbnb-direct-add-template class="w-full" *ngIf="directAddService.currentStep === 2"></sbnb-direct-add-template>

  <sbnb-direct-add-assets class="w-full" *ngIf="directAddService.currentStep >= 3"></sbnb-direct-add-assets>
</div>
